module.exports = __webpack_public_path__ + "static/media/2024.06.20 - Amended Statement of Allegations NS.f1e1024f.pdf";